import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[disableContextMenu]',
})
export class DisableContextMenuDirective {
  
  @HostListener('contextmenu', ['$event'])
  onRightClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
}